import axios from '../../../services/axios.service';

let postRequest: any = null;

const EventTriggerService = {
  sendPost: (url: string, data: any) => {
    postRequest && postRequest.cancel();
    postRequest = axios.CancelToken.source();
    return axios.post(url, data, {
      cancelToken: postRequest.token,
    });
  },
};

export default EventTriggerService;
